
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"en":{"dataProtectionContext.label":"Data protection context","noDataProtectionContextsAvailable.label":"No data protection contexts available","dataProtectionContext.newItem":"New data protection context"},"de":{"dataProtectionContext.label":"Datenschutzkontext","noDataProtectionContextsAvailable.label":"Keine Datenschutzkontexte verfügbar","dataProtectionContext.newItem":"Neuer Datenschutzkontext"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();